import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as aws from 'aws-sdk';
import {createTransport} from 'nodemailer';
import {Observable, Observer} from 'rxjs';
import {concatMap} from 'rxjs/operators';

@HookClass('aws.sns')
export class AwsSnsHook extends BaseHook {

    @Hook('ca9e10f9-9d90-410d-abee-46170f58fbed')
    public sendSms(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                return new Observable((observer: Observer<any>) => {

                    sns.setSMSAttributes({
                        attributes: {
                            DefaultSMSType: 'Transactional',
                            UsageReportS3Bucket: 'nick-sns-daily-usage',
                            DefaultSenderID: 'nick-fw'
                        }
                    });

                    const params = {
                        PhoneNumber: inputArtifact.object.data.to,
                        Message: inputArtifact.object.data.body,
                        MessageStructure: 'string'
                    };

                    sns.publish(params, (err, data) => {
                        if (err) {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ERROR;
                            uploadArtifact.object = err;
                            observer.error(uploadArtifact);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }

                        observer.complete();
                    });
                });
            }));
    }

    @Hook('f7c89c5e-2583-4fa2-9bed-9663a5bc4e69')
    public sendEmail(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const ses = new aws.SES({
                    region: 'us-east-1',
                    apiVersion: '2010-12-01',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                return new Observable((observer: Observer<any>) => {

                    const mailOptions: any = {
                        from: inputArtifact.object.data.from,
                        subject: inputArtifact.object.data.subject,
                        html: inputArtifact.object.data.body,
                        to: inputArtifact.object.data.to
                    };

                    if (inputArtifact.object.data.attachments) {
                        mailOptions.attachments = inputArtifact.object.data.attachments;
                    }

                    const transporter = createTransport({
                        SES: ses
                    });

                    transporter.sendMail(mailOptions, (err: any, data: any) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }
                        observer.complete();

                    });
                });
            }));
    }

    @Hook('6c8f2fd8-1d6c-4bcd-bb65-634395b9f02b')
    public registerDevice(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                if (!inputArtifact.object.config.arn)
                    inputArtifact.object.config.arn = 'arn:aws:sns:us-east-1:003198923998:app/GCM/nick-app';

                return new Observable((observer: Observer<any>) => {

                    const params = {
                        PlatformApplicationArn: inputArtifact.object.config.arn,
                        Token: inputArtifact.object.data.token,
                        Attributes: {}
                    };
                    sns.createPlatformEndpoint(params, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }
                        observer.complete();
                    });

                });
            }));
    }

    @Hook('85f41db6-b425-4f8d-ba3a-10c3b0f27984')
    public sendPush(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                return new Observable((observer: Observer<any>) => {

                    const jsonMessage = {
                            // tslint:disable-next-line
                            'GCM': '{ "notification": { "title": "' + inputArtifact.object.data.title + '", "body": "' + inputArtifact.object.data.message + '" } }'
                        }
                    ;

                    const params = {
                        Message: JSON.stringify(jsonMessage),
                        MessageStructure: 'json',
                        TargetArn: inputArtifact.object.data.token
                    };

                    sns.publish(params, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const uploadArtifact = new NickProcessArtfact();
                            uploadArtifact.kind = ArtfactKind.ANY;
                            uploadArtifact.object = data;
                            observer.next(uploadArtifact);
                        }
                        observer.complete();
                    });

                });
            }));
    }

    @Hook('d1e1ccac-2e89-441b-9e5e-eb96f1679dbc')
    public registerTopic(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const envPrefix = settings.environment == EnvironmentKind.DEV ? 'develop' : 'production';

                const topicName = `nick-${envPrefix}-${inputArtifact.object.config.name}-sns`;

                return new Observable((observer: Observer<any>) => {
                    sns.createTopic({Name: topicName}, (err, data) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const outputArtifact = new NickProcessArtfact();
                            outputArtifact.kind = ArtfactKind.ANY;
                            outputArtifact.object = data;
                            observer.next(outputArtifact);
                        }
                        observer.complete();
                    });

                });
            }));
    }

    @Hook('5b7f7dfb-333a-4e69-96fe-2d2cbd3ce2f5')
    public subscribeTopic(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    TopicArn: inputArtifact.object.config.arn,
                    Protocol: inputArtifact.object.config.protocol,
                    Endpoint: inputArtifact.object.config.endpoint
                };

                return new Observable((observer: Observer<any>) => {
                    sns.subscribe(params, (err: any, data: any) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const outputArtifact = new NickProcessArtfact();
                            outputArtifact.kind = ArtfactKind.ANY;
                            outputArtifact.object = data;
                            observer.next(outputArtifact);
                        }
                        observer.complete();
                    });
                });
            }));
    }

    @Hook('35ff2926-7b0d-48bc-830b-f187731f8398')
    public confirmTopicSubscription(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    TopicArn: inputArtifact.object.config.arn,
                    Token: inputArtifact.object.config.token,
                    AuthenticateOnUnsubscribe: 'true'
                };
                return new Observable((observer: Observer<any>) => {
                    sns.confirmSubscription(params, (err: any, data: any) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const outputArtifact = new NickProcessArtfact();
                            outputArtifact.kind = ArtfactKind.ANY;
                            outputArtifact.object = data;
                            observer.next(outputArtifact);
                        }
                        observer.complete();
                    });
                });
            }));
    }

    @Hook('be817b4f-051e-4329-8e18-ac62d97798b5')
    public publishTopicNotification(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const sns = new aws.SNS({
                    region: 'us-east-1',
                    apiVersion: '2010-03-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    Message: inputArtifact.object.data,
                    TopicArn: inputArtifact.object.config.arn
                };

                return new Observable((observer: Observer<any>) => {
                    sns.publish(params, (err: any, data: any) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const outputArtifact = new NickProcessArtfact();
                            outputArtifact.kind = ArtfactKind.ANY;
                            outputArtifact.object = data;
                            observer.next(outputArtifact);
                        }
                        observer.complete();
                    });
                });
            }));
    }
}
